import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const PropagationContext = /*#__PURE__*/createContext({
  continuePropagation: false
});
export const PropagationProvider = ({
  continuePropagation,
  children
}) => {
  return /*#__PURE__*/_jsx(PropagationContext.Provider, {
    value: {
      continuePropagation
    },
    children: children
  });
};

/**
 * Hook to stop event propagation if `continuePropagation` is false.
 * @example
 * const { maybeStopPropagation } = useMaybeStopPropagation();
 *
 * const onClick = useCallback(
 *  (event) => {
 *   maybeStopPropagation(event);
 * }, [maybeStopPropagation]);
 *
 */
export const useMaybeStopPropagation = () => {
  const {
    continuePropagation
  } = useContext(PropagationContext);
  return {
    maybeStopPropagation: event => {
      if (!continuePropagation && typeof event.stopPropagation === 'function') {
        event.stopPropagation();
      }
      if (continuePropagation && typeof event.continuePropagation === 'function') {
        event.continuePropagation();
      }
    }
  };
};